import { useSurveys } from "api/hooks";
import { SurveyApi, surveyApi } from "api/surveyApi";
import {
  AdminResourceDeleteModal,
  AdminSearchInput,
  FiltersBackground,
  PageHeader,
  PageMain,
} from "components/molecules";
import { routes } from "consts";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDeleteResourceActions } from "utils/store";
import {
  TanTable,
  TanTableColumn,
  useFilters,
  usePagination,
  useSorting,
} from "components/molecules";

export const SurveysPage = (): JSX.Element | null => {
  const { setDeleteResource } = useDeleteResourceActions();
  const { searchPhrase, filter, setSearchPhrase } = useFilters();
  const { limit, onPaginationChange, skip, pagination } = usePagination();
  const { sorting, onSortingChange, fieldWithOrder } = useSorting();

  const { isFetching, isLoading, invalidate, total, surveys } = useSurveys(
    skip,
    limit,
    searchPhrase,
    filter,
    fieldWithOrder,
  );

  useEffect(() => {
    invalidate();
  }, [sorting, pagination, searchPhrase, filter]);

  const navigate = useNavigate();

  const onSearchChange = (searchPhrase: string) => setSearchPhrase(searchPhrase);

  const columns = React.useMemo<TanTableColumn<SurveyApi>[]>(() => cols, []);
  return (
    <PageMain>
      <PageHeader
        button={{
          title: "Dodaj +",
          onClick: () => navigate(routes.SURVEYS_ADD),
        }}
      >
        Ankiety
      </PageHeader>

      <FiltersBackground className="mb-4">
        <div className="flex flex-wrap items-center gap-2">
          <AdminSearchInput onSearch={onSearchChange} className="self-end" />
        </div>
      </FiltersBackground>
      <TanTable
        data={surveys}
        columns={columns}
        total={total}
        loading={isLoading}
        fetching={isFetching}
        onPaginationChange={onPaginationChange}
        onSortingChange={onSortingChange}
        onDelete={(x) => setDeleteResource(x.id)}
        pagination={pagination}
        sorting={sorting}
        onEdit={(x) => navigate(routes.SURVEYS_EDIT(x.id))}
        onRowClick={(x) => navigate(routes.SURVEYS_PAGES(x.id))}
      />
      <AdminResourceDeleteModal
        title="Usuń ankietę"
        description="Jesteś pewien że chcesz usunąć ankietę?"
        onSuccessDelete={() => invalidate()}
        deleteAction={surveyApi.delete}
      />
    </PageMain>
  );
};

const cols: TanTableColumn<SurveyApi>[] = [
  {
    id: "id",
    accessorKey: "id",
    header: "ID",
    enableColumnFilter: false,
  },
  {
    id: "name",
    accessorKey: "name",
    header: "Nazwa",
    enableColumnFilter: false,
  },
  {
    id: "status",
    accessorKey: "status",
    header: "Status",
    enableColumnFilter: false,
  },
];
